import { Component, h } from 'preact';
import { FinText } from '../../../i18n';
import { Properties } from '../../../common';
import { BookingState, connectStore } from '../../../store';
import { WithStyles, withStyles } from '../../../style';
import Notification, { Severity } from '../Notification/Notification';

interface StoreProps {
  open: boolean;
}

type EffectiveProps = Properties & StoreProps & WithStyles;

const mapStateToProps = ({ selection: { locations, activeLocationIndex } }: BookingState): StoreProps => ({
  open: ['origin', 'destination'].some((key) =>
    ['TKU', 'TMP', 'XTP', 'XTZ'].includes(locations[activeLocationIndex]?.[key]?.locationCode)
  ),
});

@withStyles()
@connectStore({ mapStateToProps })
export default class BusConnectionNotification extends Component<Properties> {
  render({ open }: EffectiveProps): h.JSX.Element {
    return (
      <Notification open={open} severity={Severity.INFO}>
        {open && <FinText id="notification.busConnection" />}
      </Notification>
    );
  }
}
